import React from 'react';
import parse from 'html-react-parser';

export default function OptionDescription({description}) {
  return description && (<div className="app-option-description">{parse(description)}</div>);
};
